<template>
    <span>
        <HotelReport v-if="this.reportDetails.project_type == 'hotel_report'" :reportDetails="reportDetails" />
        <iframe title="" id="project-iframe" v-if="this.reportDetails.project_type == 'report'" style="height:100%;width:100%;border:0" :src="hash"></iframe>
        <div v-if="bool === false"> 
            <div class="denied">
                <h1>Access denied</h1>
                <p>This Report share url is not active.</P>
            </div>
        </div>
    </span>
</template>

<script>
import HotelReport from '@/components/reports/HotelReport.vue';

window.cardSystemDownloadData = false;
window.cardSystemExportPDF = false;
window.cardSystemEmbed = false;



export default {
  name: "ShareLayout",
  components: { HotelReport },
  data() {
    return {
        hash: '',
        bool: null,
        report: {},
        cards_base_url: "https://cards.ubermedia.com",
        reportDetails: {},
    }
  },
  methods: {
    async getLink(){
        try{
            const data = await this.$http.get(`${process.env.VUE_APP_PINNACLE_API}/v2/get-share-project/${this.$route.params.hash}`);
            console.log(data);
            if(data.status === 200){
                this.reportDetails = data.data;
                this.hash = `${this.cards_base_url}/${this.reportDetails.project_hash}/`
                let urlParams = new URLSearchParams(window.location.search);
                if (urlParams.has('c')) {
                    this.hash = this.hash + urlParams.get('c');
                }
                this.bool = true;
            }
        }
        catch(error){
            if (error.response && error.response.status === 404) {
            this.reportDetails = {statusCode: 404, message: "Report not found"};
            }
            this.bool = false;
        }
    },
    onIframeMessage(event) {
        //console.log(event)
        // if (event.data.message == 'refresh_page') {
        //     location.reload();
        // return;
        // }
        if (event.data && event.data.message == "pdf_export") {
            this.openExportPDFModal(this.reportDetails);
        }
    },
   /**
     * Opens the export as PDF modal for a given report.
     * @param {*} report 
     */
     openExportPDFModal(report) {
      const clone = { id: report.id, name: report.name };
      this.$router.push({
        query: {
          exportPDF: btoa(JSON.stringify(clone))
        }
      });
    },
  },
  mounted() {
    window.cardSystemExportPDF = false;
    // let host = window.location.host;
    // if (host.indexOf("pinnacle.near.com") == -1) {
    //     this.cards_base_url = "https://cards.ubermedia.com"
    // }
    // if (host.indexOf("localhost") !== -1) {
    //     this.cards_base_url = "http://uber.ravefire.com:3000"
    // }
    this.getLink();
    window.addEventListener("message", this.onIframeMessage, false);
    setTimeout(() => {
        var head = document.head;
        var script = document.createElement("script");
        script.type = "text/javascript";
        let baseUrl = this.cards_base_url;
        script.src = baseUrl+"/js/CardRouting.js";
        head.appendChild(script);        
    }, 1000);
  }
};
</script>

<style>
    .denied{
        margin-left: 35%;
        margin-top: 5%;
    }
</style>